import { render, staticRenderFns } from "./SignUpBlock.vue?vue&type=template&id=2dc10050&scoped=true&"
import script from "./SignUpBlock.vue?vue&type=script&lang=js&"
export * from "./SignUpBlock.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBlock.vue?vue&type=style&index=0&id=2dc10050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc10050",
  null
  
)

export default component.exports